import { axios } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { useMutation } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const updateKeyDefinition = ({ data, keyDefinitionId }) => {
    if (keyDefinitionId)
        return axios.patch(`/api/v1/agent/metric`, { ...data, metricId: keyDefinitionId });
};

export const useUpdateKeyDefinition = () => {
    const { addNotification } = useNotificationStore();
    const navigate = useNavigate();
    const { keyDefinitionId } = useParams();
    return useMutation({
        onError: async (data, { keyDefinitionId, justToggle }) => {
            addNotification({
                type: 'error',
                title: data?.response?.data?.error?.message || 'Failed to Update Key Definition',
            });
            if (justToggle) {
                queryClient.setQueryData('getConnectedDefinitionsList', (elem) => {
                    let manipulateData = structuredClone(elem);
                    let index = manipulateData?.metrics.findIndex((dat) => dat._id === keyDefinitionId)
                    manipulateData.metrics[index].enabled = !manipulateData.metrics[index].enabled;
                    return manipulateData;
                });
            }

        },
        onSuccess: async (data) => {
            addNotification({
                type: 'success',
                title: `Key Definition Updated Successfully`,
            });
            navigate("/admin/data-catalog");
            if (keyDefinitionId && keyDefinitionId !== 'new-definition')
                queryClient.refetchQueries('getConnectedDefinitionsList')
        },
        mutationFn: updateKeyDefinition,
    });
};